<template>
  <v-main class="card">


    <nav class="navbar navbar-light bg-light">
      <span class="navbar-text">
        <h5>New Conference</h5>
      </span>
      <button @click="close();" class="right btn btn-primary" >Cancel</button>
    </nav>
    <div class="card-body">

      <div class="form-group has-success">
        <label class="control-label" for="confNameTxt">Conference Name</label>
        <input id="confNameTxt" type="text" v-model="confname" class="form-control">
      </div>

      <div class="form-group" style="position:relative" >
        <label class="control-label" for="conftype">Select conference type</label>
        <select id="conftype" class="form-control" v-model="confType">
          <option value="Meeting">Meeting</option>
          <option value="Presentation">Presentation</option>
        </select>
      </div> 

      <div class="form-group has-success">
        <label class="control-label">Company Access</label>
        <br>
        <label class="switch">
          <input type="checkbox" v-model="companyAccess">
          <span class="slider round"></span>
        </label>
      </div>

      <div class="form-group">
        <button class="btn btn-primary" @click="createConference()">Create</button>
      </div>
    </div>
  </v-main>

</template>

<script >
import Common from '../mixins/common';
export default
{
  components: {  },
  mixins: [Common],
  data: function() {
    return {
      test: {},
      companyAccess: false,
      confname: '',
      confType: "Small Group"
    }
  },
  methods: {
    close: function() {
      this.$router.push('/conferences')
    },
    createConference: function() {
      this.$http.get(
        global.apiurl + "/conference/create&" +
          "token=" + encodeURIComponent(this.click2call) +
          "&name=" + encodeURIComponent(this.confname) +
          "&companyAccess=" + encodeURIComponent(this.companyAccess) +
          "&conferenceType=" + encodeURIComponent(this.confType)
      ).then(function() {
        this.$store.dispatch('conference/getConferences');
        this.close();
      })

    },
  },
  filters: {

  },
}
</script>

<style>
.right {
  position:absolute;
  right:10px
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {display:none;}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

</style>
